import { SlicedSuggestions } from 'types/suggestions';

export const SPONSORED_INSERT_AFTER_NEW_SUGGESTIONS = 3;

export const getProductElementIndex = (
  idx: number,
  isDefaultList: boolean,
  akinatorOffset = 0,
  defaultListPinnedOffset = 0,
  itemIndexOffset = 0,
) => {
  const index = itemIndexOffset + idx;
  return isDefaultList ? defaultListPinnedOffset + index : akinatorOffset + index;
};

export const getCategoryElementIndex = (
  idx: number,
  suggestions: SlicedSuggestions,
  isDefaultList: boolean,
  akinatorOffset = 0,
  defaultListPinnedOffset = 0,
) => {
  const products = suggestions[0];
  const index = products.length + idx;
  return isDefaultList ? defaultListPinnedOffset + index : akinatorOffset + index;
};

export const getSponsoredElementIndex = (
  productIndex: number,
  suggestions: SlicedSuggestions,
  isDefaultList: boolean,
  akinatorOffset = 0,
  defaultListPinnedOffset = 0,
  newSuggestionsBeforeSponsored?: number,
) => {
  const products = suggestions[0];
  const categories = suggestions[1];
  const index = (newSuggestionsBeforeSponsored ?? products.length) + categories.length + productIndex;
  return isDefaultList ? defaultListPinnedOffset + index : akinatorOffset + index;
};
